// Characters API service for CRUD operations

import {
  createCharacterFunction,
  updateCharacterFunction,
  adminUpdateCharacterFunction,
  levelUpCharacterFunction,
  getCharacterDetailsFunction,
  awardExperienceFunction,
  spendDowntimeDaysFunction,
  deleteCharacterFunction,
  transferDMTokenToCharacterTypedFunction,
  CreateCharacterData,
  UpdateCharacterData,
  AdminUpdateCharacterData,
  LevelUpCharacterData,
  GetCharacterDetailsData,
  AwardExperienceData,
  SpendDowntimeDaysData,
  DeleteCharacterData,
  TransferDMTokenData,
  CreateCharacterResponse,
  UpdateCharacterResponse,
  AdminUpdateCharacterResponse,
  LevelUpCharacterResponse,
  GetCharacterDetailsResponse,
  AwardExperienceResponse,
  SpendDowntimeDaysResponse,
  DeleteCharacterResponse,
  TransferDMTokenResponse,
} from "../firebase/functions";

/**
 * Create a new character
 */
export const createCharacter = async (
  data: CreateCharacterData
): Promise<CreateCharacterResponse> => {
  const result = await createCharacterFunction(data);
  return result.data as CreateCharacterResponse;
};

/**
 * Update an existing character
 */
export const updateCharacter = async (
  data: UpdateCharacterData
): Promise<UpdateCharacterResponse> => {
  const result = await updateCharacterFunction(data);
  return result.data as UpdateCharacterResponse;
};

/**
 * Admin update character (Admin only)
 */
export const adminUpdateCharacter = async (
  data: AdminUpdateCharacterData
): Promise<AdminUpdateCharacterResponse> => {
  try {
    const result = await adminUpdateCharacterFunction(data);
    return result.data as AdminUpdateCharacterResponse;
  } catch (error) {
    // Error updating character - rethrow for handling by caller
    throw error;
  }
};

/**
 * Level up a character by spending memento tokens
 */
export const levelUpCharacter = async (
  data: LevelUpCharacterData
): Promise<LevelUpCharacterResponse> => {
  try {
    const result = await levelUpCharacterFunction(data);
    return result.data as LevelUpCharacterResponse;
  } catch (error) {
    // Error leveling up character - rethrow for handling by caller
    throw error;
  }
};

/**
 * Get detailed character information
 */
export const getCharacterDetails = async (
  data: GetCharacterDetailsData
): Promise<GetCharacterDetailsResponse> => {
  try {
    const result = await getCharacterDetailsFunction(data);
    return result.data as GetCharacterDetailsResponse;
  } catch (error) {
    // Error getting character details - rethrow for handling by caller
    throw error;
  }
};

/**
 * Award experience to a character (DM/Admin only)
 */
export const awardExperience = async (
  data: AwardExperienceData
): Promise<AwardExperienceResponse> => {
  try {
    const result = await awardExperienceFunction(data);
    return result.data as AwardExperienceResponse;
  } catch (error) {
    // Error awarding experience - rethrow for handling by caller
    throw error;
  }
};

/**
 * Spend downtime days for a character
 */
export const spendDowntimeDays = async (
  data: SpendDowntimeDaysData
): Promise<SpendDowntimeDaysResponse> => {
  try {
    const result = await spendDowntimeDaysFunction(data);
    return result.data as SpendDowntimeDaysResponse;
  } catch (error) {
    // Error spending downtime days - rethrow for handling by caller
    throw error;
  }
};

/**
 * Delete a character
 */
export const deleteCharacter = async (
  data: DeleteCharacterData
): Promise<DeleteCharacterResponse> => {
  try {
    const result = await deleteCharacterFunction(data);
    return result.data as DeleteCharacterResponse;
  } catch (error) {
    // Error deleting character - rethrow for handling by caller
    throw error;
  }
};

/**
 * Transfer DM tokens to character memento tokens
 */
export const transferDMTokenToCharacter = async (
  data: TransferDMTokenData
): Promise<TransferDMTokenResponse> => {
  try {
    const result = await transferDMTokenToCharacterTypedFunction(data);
    return result.data as TransferDMTokenResponse;
  } catch (error) {
    // Error transferring DM tokens - rethrow for handling by caller
    throw error;
  }
};
